@if (
  this.actionStack!.getValue('couvertureManuelleIPresenceCouverture') === 1
) {
  <app-larged-tuile
    icon="fa-kit fa-picto-couverture"
    [title]="'dashboard.cover' | translate"
    [buttons]="buttons"
    [status]="
      buttons[this.actionStack!.getValue('couvertureManuelleSEtatVolet')].title!
    "
    [statusMode]="
      buttons[this.actionStack!.getValue('couvertureManuelleSEtatVolet')]
        .status!
    "
    [selectItem]="this.actionStack!.getValue('couvertureManuelleCEtatVolet')"
    (onPressSetting)="this.openProductModal()"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.CouvertureManuelle_Controle,
        'couvertureManuelleCEtatVolet',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-larged-tuile>
}
